import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import app from './app'
import users from './users'
import teams from './teams'
import runbooks from './runbooks'
import ui from './ui'
import cmdb from './cmdb'

const history = (history) =>
    combineReducers({
        router: connectRouter(history),
        app,
        users,
        teams,
        runbooks,
        ui,
        cmdb,
    })

export default history
